import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import register from '@/pages/Register'
import login from '@/pages/Login'
import confirmEmail from '@/pages/ConfirmEmail'
import resetPassword from '@/pages/ResetPassword'

// import home from '@/pages/Home'

import allClients from '@/pages/client/AllClients'
import clients from '@/pages/client/Clients'
import clientDetails from '@/pages/client/ClientDetails'
import apartmentClientDetails from '@/pages/client/ApartmentClientDetails'
import clientAdd from '@/pages/client/ClientAdd'
import clientEdit from '@/pages/client/ClientEdit'

import cities from '@/pages/city/Cities'
import cityDetails from '@/pages/city/CityDetails'
import cityAdd from '@/pages/city/CityAdd'
import cityEdit from '@/pages/city/CityEdit'

import districts from '@/pages/district/Districts'
import districtDetails from '@/pages/district/DistrictDetails'
import districtAdd from '@/pages/district/DistrictAdd'
import districtEdit from '@/pages/district/DistrictEdit'

import addresses from '@/pages/address/Addresses'
import addressDetails from '@/pages/address/AddressDetails'
import addressAdd from '@/pages/address/AddressAdd'
import addressEdit from '@/pages/address/AddressEdit'

import buildings from '@/pages/building/Buildings'
import buildingDetails from '@/pages/building/BuildingDetails'
import buildingAdd from '@/pages/building/BuildingAdd'
import buildingEdit from '@/pages/building/BuildingEdit'

import blocks from '@/pages/block/Blocks'
import blockDetails from '@/pages/block/BlockDetails'
import blockAdd from '@/pages/block/BlockAdd'
import blockEdit from '@/pages/block/BlockEdit'

import printOrders from '@/pages/print_order/PrintOrders'

import apartments from '@/pages/apartment/Apartments'
import apartmentDetails from '@/pages/apartment/ApartmentDetails'
import apartmentAdd from '@/pages/apartment/ApartmentAdd'
import apartmentBulkAdd from '@/pages/apartment/ApartmentBulkAdd'
import apartmentEdit from '@/pages/apartment/ApartmentEdit'

import transactions from '@/pages/transaction/Transactions'
import clientTransactions from '@/pages/transaction/ClientTransactions'
import apartmentClientTransactions from '@/pages/transaction/ApartmentClientTransactions'
import clientTransactionDetails from '@/pages/transaction/ClientTransactionDetails'
import apartmentClientTransactionDetails from '@/pages/transaction/ApartmentClientTransactionDetails'
import transactionDetails from '@/pages/transaction/TransactionDetails'
import transactionAdd from '@/pages/transaction/TransactionAdd'
import apartmentClientTransactionAdd from '@/pages/transaction/ApartmentClientTransactionAdd'
import transactionEdit from '@/pages/transaction/TransactionEdit'
import apartmentClientTransactionEdit from '@/pages/transaction/ApartmentClientTransactionEdit'

import bankTransactions from '@/pages/bank_transaction/BankTransactions'
import bankTransactionDetails from '@/pages/bank_transaction/BankTransactionDetails'

import privatAuth from '@/pages/PrivatAuth'
import privatOtpAuth from '@/pages/PrivatOtpAuth'

import ratePlans from '@/pages/rate_plan/RatePlans'
import ratePlanDetails from '@/pages/rate_plan/RatePlanDetails'
import ratePlanAdd from '@/pages/rate_plan/RatePlanAdd'
import ratePlanEdit from '@/pages/rate_plan/RatePlanEdit'

import discounts from '@/pages/discount/Discounts'
import discountDetails from '@/pages/discount/DiscountDetails'
import discountAdd from '@/pages/discount/DiscountAdd'
import discountEdit from '@/pages/discount/DiscountEdit'

import billTemplates from '@/pages/bill_template/BillTemplates'
import billTemplateDetails from '@/pages/bill_template/BillTemplateDetails'
import billTemplateAdd from '@/pages/bill_template/BillTemplateAdd'
import billTemplateEdit from '@/pages/bill_template/BillTemplateEdit'

import claims from '@/pages/claim/Claims'
import claimDetails from '@/pages/claim/ClaimDetails'
import claimAdd from '@/pages/claim/ClaimAdd'
import claimEdit from '@/pages/claim/ClaimEdit'

import companyEdit from '@/pages/company/CompanyEdit'

import auth from '@/auth'

const routes = [
  { path: '/register', name: 'register', component: register },
  { path: '/login', name: 'login', component: login, beforeEnter: auth.goHome },
  { path: '/confirm-email', name: 'confirm-email', component: confirmEmail },
  { path: '/reset-password', name: 'reset-password', component: resetPassword },

  // { path: '/', name: 'home', component: home, beforeEnter: auth.requireAuth },
  {
    path: '/clients',
    name: 'all-clients',
    component: allClients,
    beforeEnter: auth.requireAuth
  },
  {
    path: '/clients/:client_id',
    component: clientDetails,
    beforeEnter: auth.requireAuth,
    children: [
      { path: '', name: 'client-details', component: clientTransactions, beforeEnter: auth.requireAuth },
      { path: 'transactions/:transaction_id', name: 'client-transaction-details', component: clientTransactionDetails, beforeEnter: auth.requireAuth },
      { path: 'transaction/add', name: 'transaction-add', component: transactionAdd, beforeEnter: auth.requireAuth },
      { path: 'transactions/:transaction_id/edit', name: 'transaction-edit', component: transactionEdit, beforeEnter: auth.requireAuth }
    ]
  },

  { path: '/', name: 'cities', component: cities, beforeEnter: auth.requireAuth },
  { path: '/city/add', name: 'city-add', component: cityAdd, beforeEnter: auth.requireAuth },
  { path: '/cities/:city_id/edit', name: 'city-edit', component: cityEdit, beforeEnter: auth.requireAuth },
  {
    path: '/cities/:city_id',
    component: cityDetails,
    beforeEnter: auth.requireAuth,
    children: [
      { path: 'districts', name: 'city-details', component: districts, beforeEnter: auth.requireAuth },
      { path: 'district/add', name: 'district-add', component: districtAdd, beforeEnter: auth.requireAuth },
      { path: 'districts/:district_id/edit', name: 'district-edit', component: districtEdit, beforeEnter: auth.requireAuth },
      {
        path: 'districts/:district_id',
        component: districtDetails,
        beforeEnter: auth.requireAuth,
        children: [
          { path: 'addresses', name: 'district-details', component: addresses, beforeEnter: auth.requireAuth },
          { path: 'address/add', name: 'address-add', component: addressAdd, beforeEnter: auth.requireAuth },
          { path: 'addresses/:address_id/edit', name: 'address-edit', component: addressEdit, beforeEnter: auth.requireAuth },
          {
            path: 'addresses/:address_id',
            component: addressDetails,
            beforeEnter: auth.requireAuth,
            children: [
              { path: '', name: 'address-details', component: buildings, beforeEnter: auth.requireAuth },
              { path: 'building/add', name: 'building-add', component: buildingAdd, beforeEnter: auth.requireAuth },
              { path: 'building/:building_id/edit', name: 'building-edit', component: buildingEdit, beforeEnter: auth.requireAuth },
              {
                path: 'buildings/:building_id',
                component: buildingDetails,
                beforeEnter: auth.requireAuth,
                children: [
                  { path: '', name: 'building-details', component: blocks, beforeEnter: auth.requireAuth },
                  { path: 'block/add', name: 'block-add', component: blockAdd, beforeEnter: auth.requireAuth },
                  { path: 'blocks/:block_id/edit', name: 'block-edit', component: blockEdit, beforeEnter: auth.requireAuth },
                  {
                    path: 'blocks/:block_id',
                    component: blockDetails,
                    beforeEnter: auth.requireAuth,
                    children: [
                      { path: '', name: 'block-details', component: apartments, beforeEnter: auth.requireAuth },
                      { path: 'apartment/add', name: 'apartment-add', component: apartmentAdd, beforeEnter: auth.requireAuth },
                      { path: 'apartment/bulk-add', name: 'apartment-bulk-add', component: apartmentBulkAdd, beforeEnter: auth.requireAuth },
                      { path: 'apartments/:apartment_id/edit', name: 'apartment-edit', component: apartmentEdit, beforeEnter: auth.requireAuth },
                      {
                        path: 'apartments/:apartment_id',
                        component: apartmentDetails,
                        beforeEnter: auth.requireAuth,
                        children: [
                          { path: '', name: 'apartment-details', component: clients, beforeEnter: auth.requireAuth },
                          { path: 'client/add', name: 'client-add', component: clientAdd, beforeEnter: auth.requireAuth },
                          { path: 'clients/:client_id/edit', name: 'client-edit', component: clientEdit, beforeEnter: auth.requireAuth },
                          {
                            path: 'clients/:client_id',
                            component: apartmentClientDetails,
                            beforeEnter: auth.requireAuth,
                            children: [
                              { path: '', name: 'apartment-client-details', component: apartmentClientTransactions, beforeEnter: auth.requireAuth },
                              { path: 'transactions/:transaction_id', name: 'apartment-client-transaction-details', component: apartmentClientTransactionDetails, beforeEnter: auth.requireAuth },
                              { path: 'transaction/add', name: 'apartment-client-transaction-add', component: apartmentClientTransactionAdd, beforeEnter: auth.requireAuth },
                              { path: 'transactions/:transaction_id/edit', name: 'apartment-client-transaction-edit', component: apartmentClientTransactionEdit, beforeEnter: auth.requireAuth }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },

  { path: '/claims', name: 'claims', component: claims, beforeEnter: auth.requireAuth },
  { path: '/claims/:id', name: 'claim-details', component: claimDetails, beforeEnter: auth.requireAuth },
  { path: '/claim/add', name: 'claim-add', component: claimAdd, beforeEnter: auth.requireAuth },
  { path: '/claims/:id/edit', name: 'claim-edit', component: claimEdit, beforeEnter: auth.requireAuth },

  { path: '/transactions', name: 'transactions', component: transactions, beforeEnter: auth.requireAuth },
  { path: '/transactions/:transaction_id', name: 'transaction-details', component: transactionDetails, beforeEnter: auth.requireAuth },

  { path: '/bank-transactions', name: 'bank-transactions', component: bankTransactions, beforeEnter: auth.requireAuth },
  { path: '/bank-transactions/:bank_transaction_id', name: 'bank-transaction-details', component: bankTransactionDetails, beforeEnter: auth.requireAuth },

  { path: '/privat-auth', name: 'privat-auth', component: privatAuth, beforeEnter: auth.requireAuth },
  { path: '/privat-otp-auth', name: 'privat-otp-auth', component: privatOtpAuth, beforeEnter: auth.requireAuth },

  { path: '/rate-plans', name: 'rate-plans', component: ratePlans, beforeEnter: auth.requireAuth },
  { path: '/rate-plans/:id', name: 'rate-plan-details', component: ratePlanDetails, beforeEnter: auth.requireAuth },
  { path: '/rate-plan/add', name: 'rate-plan-add', component: ratePlanAdd, beforeEnter: auth.requireAuth },
  { path: '/rate-plans/:id/edit', name: 'rate-plan-edit', component: ratePlanEdit, beforeEnter: auth.requireAuth },

  { path: '/discounts', name: 'discounts', component: discounts, beforeEnter: auth.requireAuth },
  { path: '/discounts/:id', name: 'discount-details', component: discountDetails, beforeEnter: auth.requireAuth },
  { path: '/discount/add', name: 'discount-add', component: discountAdd, beforeEnter: auth.requireAuth },
  { path: '/discounts/:id/edit', name: 'discount-edit', component: discountEdit, beforeEnter: auth.requireAuth },

  { path: '/bill-templates', name: 'bill-templates', component: billTemplates, beforeEnter: auth.requireAuth },
  { path: '/bill-templates/:id', name: 'bill-template-details', component: billTemplateDetails, beforeEnter: auth.requireAuth },
  { path: '/bill-template/add', name: 'bill-template-add', component: billTemplateAdd, beforeEnter: auth.requireAuth },
  { path: '/bill-templates/:id/edit', name: 'bill-template-edit', component: billTemplateEdit, beforeEnter: auth.requireAuth },

  { path: '/print-orders', name: 'print-orders', component: printOrders, beforeEnter: auth.requireAuth },

  { path: '/settings', name: 'settings', component: companyEdit, beforeEnter: auth.requireAuth }
]

let router = new Router({
  mode: 'history',
  routes,
  linkActiveClass: 'active'
})

router.beforeEach((to, from, next) => {
  localStorage.setItem('previous_page_path', from.path)

  let query = ''
  for (let key in from.query) {
    if (query) {
      query += '&'
    }
    query += key + '=' + from.query[key]
  }
  if (query) {
    query = '?' + query
  }

  localStorage.setItem('previous_page_query', query)
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js